export default "__VITE_ASSET__cf9888ad__"